import MasterCardIcon from './MasterCardIcon';

export default MasterCardIcon;
